const ONE_DAY_MS = 8.64e7;

const daysBetween = (startDate, endDate) => {
  // The number of milliseconds in all UTC days (no DST)
  const oneDay = 1000 * 60 * 60 * 24;

  // A day in UTC always lasts 24 hours (unlike in other time formats)
  const start = Date.UTC(
    endDate.getFullYear(),
    endDate.getMonth(),
    endDate.getDate(),
  );
  const end = Date.UTC(
    startDate.getFullYear(),
    startDate.getMonth(),
    startDate.getDate(),
  );

  return (start - end) / oneDay;
};

export const getDaysUntilDate = targetDate => {
  if (!targetDate) {
    return null;
  }

  const now = new Date();

  return daysBetween(now, new Date(targetDate));
};

export const hasDatePassed = (dateString, daysUntil) => {
  const daysSinceDismissed = Math.floor(
    (new Date() - new Date(dateString)) / ONE_DAY_MS,
  );
  return daysSinceDismissed > daysUntil;
};

export const formatRegistryLinkedTime = linkedTime => {
  if (!linkedTime) {
    return '';
  }
  return new Date(linkedTime).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
  });
};

export const formatProductSyncLastRunTime = lastRunTime => {
  if (!lastRunTime) {
    return '';
  }
  let dayString = 'today';
  if (new Date() - new Date(lastRunTime) <= 90 * 1000) {
    return 'just now';
  }
  if (new Date().toDateString() !== new Date(lastRunTime).toDateString()) {
    dayString = formatRegistryLinkedTime(lastRunTime);
  }
  return `${dayString} at ${new Date(lastRunTime)
    .toLocaleString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    })
    .toLowerCase()}`;
};
